import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from '../../../../assets/components/util/Routing';
import AudioPlayer from "./AudioPlayer";

function formatFileSize(bytes, si = true) {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }

    const units = si
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;

    do {
        bytes /= thresh;
        ++u;
    } while (Math.abs(bytes) >= thresh && u < units.length - 1);

    return bytes.toFixed(1) + ' ' + units[u];
}

const ThreadFile = ({threadFile}) => {

    return (
        <span>
            <span>
            <Link
                title={formatFileSize(threadFile.fileSize) + '\n' + threadFile.mimeType}
                route="imatic_communicator_thread_download"
                params={{threadFile: threadFile.id}}
                data-ajaxify="false"
            >
                {threadFile.originalName}
                    </Link>
            </span>
                <AudioPlayer fileId={threadFile.id} fileName={threadFile.originalName}/>
        </span>
    );
}

ThreadFile.propTypes = {
    threadFile: PropTypes.any.isRequired,
};

export default connect(
    (state, props) => ({
        threadFile: state.getIn(['threadFiles', parseInt(props.threadFile)])
    })
)(ThreadFile);
